import styled from 'styled-components/native';


export const ViewButton = styled.View`
  padding: 0.5rem 0rem;
  align-items: center;
  justify-content: center;
  flex-direction: row;
`;